import React from "react";
import { connect } from "react-redux";
import { Container, Grid, Header, List, Segment } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { Translate } from "react-localize-redux";
import { hasPermission} from "../../reducer";

class Footer extends React


.Component {

    render(){
        return(
            <Segment inverted vertical style={{ padding: '5em 0em' }}>
                <Container>
                    <Grid divided inverted stackable centered>
                        <Grid.Row>
                            <Grid.Column width={3}>
                                <Header inverted as='h4' >
                                    <Translate id="footer.links.header" />
                                </Header>

                                <List link inverted>
                                    {this.props.hasPermission('clock') &&
                                    <List.Item as={Link} to={'/'}>
                                        <Translate id="footer.links.clock"/>
                                    </List.Item>
                                    }
                                    {this.props.hasPermission('stockTaking') &&
                                    <List.Item as={Link} to={'/inventory'}>
                                        <Translate id="footer.links.inventory"/>
                                    </List.Item>
                                    }

                                    {this.props.hasPermission('inventory') &&
                                    <List.Item as={Link} to={'/profile/settings'}>
                                        <Translate id="footer.links.profile"/>
                                    </List.Item>
                                    }
                                </List>
                            </Grid.Column>
                            <Grid.Column width={6}>
                                <Header inverted as='h4' >
                                    <Translate id="footer.contact"/>
                                </Header>
                                <List>
                                    <List.Item icon='marker' content='Bionstrasse 1, 9015 St.Gallen, SG' />
                                    <List.Item icon='mail' content={<a href='mailto:info@rutishauser-weinkulturen.ch'>info@rutishauser-weinkulturen.ch</a>} />
                                    <List.Item icon='phone' content={<a href='tel:+41794591681'>+41 79 459 16 81</a>} />
                                </List>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Container>
            </Segment>
        )
    }
}

const mapStateToProps = state => ({
    hasPermission: (permission)=>{return hasPermission(state, permission)}

});
export default connect(mapStateToProps)(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer/index.js